<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid>
    <v-progress-linear :height="2" :indeterminate="true"></v-progress-linear>
  </v-container>
</template>

<script>
export default {
  name: 'authorize',
  async created() {
    if (this.$route.query.code) {
      try {
        const token = await this.$api.auth.token(this.$route.query.code);
        this.$cookies.set('token', token, '1y');
        // this.$router.push({ name: 'root' });
        const { href } = this.$router.resolve({ name: 'root' });
        top.location.href = href;
      } catch (err) {
        console.log(err);
        this.$store.commit('snackbar/show', (err.response && err.response.data && err.response.data.message) || err.message);
        throw err;
      }
    } else {
      this.$router.push({ name: 'root' });
    }
  },
};
</script>
